import {departmentOptions, userRoleOptions} from '@/shared/types/common.ts';
import {z} from 'zod';

export const EMPLOYEES_TABLE = {
    TABLE: 'employees',
    ID: 'id',
    EMAIL: 'email',
    NAME: 'name',
    ROLE: 'role',
    DEPARTMENT: 'department',
    ACTIVE: 'active',
    CREATED_AT: 'created_at',
    UPDATED_AT: 'updated_at',
} as const;

export const employeeSchema = z.object({
    [EMPLOYEES_TABLE.ID]: z.uuid(),
    [EMPLOYEES_TABLE.EMAIL]: z.email(),
    [EMPLOYEES_TABLE.NAME]: z.string().min(1),
    [EMPLOYEES_TABLE.ROLE]: userRoleOptions,
    [EMPLOYEES_TABLE.DEPARTMENT]: departmentOptions.nullable(),
    [EMPLOYEES_TABLE.ACTIVE]: z.boolean(),
    [EMPLOYEES_TABLE.CREATED_AT]: z.string(),
    [EMPLOYEES_TABLE.UPDATED_AT]: z.string().nullish(),
});

export type Employee = z.infer<typeof employeeSchema>;

// =============================================
// EMPLOYEE NAMES
// =============================================

/**
 * Known employee names for commission rate lookups.
 * These must match the 'name' field in the employees table exactly.
 * Used to provide type-safe employee name references throughout the codebase.
 */
export const EMPLOYEE_NAMES = {
    ANA: 'Ana',
    GILDA: 'Gilda',
    MAYARA: 'Mayara',
    ROSANGELA: 'Rosângela',
    DENIRA: 'Denira',
    NEIA: 'Neia',
    DANYELA: 'Danyela',
    LEIDE: 'Leide',
    MARLENE: 'Marlene',
    REGINA: 'Regina',
} as const;

export type EmployeeName = (typeof EMPLOYEE_NAMES)[keyof typeof EMPLOYEE_NAMES];
